export const variantIds: any = {
    jp: ['51993088622959', '51993093767535', '51993096356207', '51993101631855'],
    eu: ['50740155875671', '50740157382999', '50740158071127', '50740159218007'],
    uk: ['51047157825875', '51047163396435', '51047172211027', ''],
    de: ['56076475171197', '56076476449149', '56076477432189', '56076478447997'],
    fr: ['50627140485467', '50627140813147', '50627141402971', '50627143565659'],
    it: ['55140789584248', '55140789846392', '55140789944696', '55140790043000'],
    es: ['50627174367579', '50627176595803', '50627177054555', '50627177415003'],
    us: ['54593875509321', '54593876000841', '54627329474633', '54593877606473'],
    ca: ['52731600175475', '52731601256819', '52731601584499', '52731615412595'],
    ph: ['52941429604662', '52941429702966', '52748208537910', ''],
    nl: ['51194425377044', '51194425147668', '51194425213204'],
};

export const linksMore: any = {
    jp: [
        'https://jp.ecoflow.com/products/rapid-pro-x-power-bank-27650mah-140w',
        'https://jp.ecoflow.com/products/rapid-pro-power-bank-27650mah-300w-140w-usb-c',
        'https://jp.ecoflow.com/products/rapid-pro-power-bank-20000mah-230w-100w-usb-c',
        'https://jp.ecoflow.com/products/rapid-pro-3-in-1-power-bank-10000mah-67w',
    ],
    eu: [
        'https://eu.ecoflow.com/products/rapid-pro-x-power-bank',
        'https://eu.ecoflow.com/products/rapid-pro-27k-power-bank',
        'https://eu.ecoflow.com/products/rapid-pro-20k-power-bank',
        'https://eu.ecoflow.com/products/rapid-pro-desktop-charger-320w',
    ],
    nl: [
        'https://nl.ecoflow.com/products/rapid-pro-27k-power-bank',
        'https://nl.ecoflow.com/products/rapid-pro-20k-power-bank',
        'https://nl.ecoflow.com/products/rapid-pro-desktop-charger-320w',
    ],
    uk: [
        'https://uk.ecoflow.com/products/rapid-pro-x-power-bank',
        'https://uk.ecoflow.com/products/rapid-pro-27k-power-bank',
        'https://uk.ecoflow.com/products/rapid-pro-20k-power-bank',
        'https://uk.ecoflow.com/products/rapid-pro-desktop-charger-320w',
    ],
    de: [
        'https://de.ecoflow.com/products/rapid-pro-x-power-bank',
        'https://de.ecoflow.com/products/rapid-pro-27k-power-bank',
        'https://de.ecoflow.com/products/rapid-pro-20k-power-bank',
        'https://de.ecoflow.com/products/rapid-pro-desktop-charger-320w',
    ],
    fr: [
        'https://fr.ecoflow.com/products/rapid-pro-x-power-bank',
        'https://fr.ecoflow.com/products/rapid-pro-27k-power-bank',
        'https://fr.ecoflow.com/products/rapid-pro-20k-power-bank',
        'https://fr.ecoflow.com/products/rapid-pro-desktop-charger-320w',
    ],
    it: [
        'https://it.ecoflow.com/products/rapid-pro-x-power-bank',
        'https://it.ecoflow.com/products/rapid-pro-27k-power-bank',
        'https://it.ecoflow.com/products/rapid-pro-20k-power-bank',
        'https://it.ecoflow.com/products/rapid-pro-desktop-charger-320w',
    ],
    es: [
        'https://es.ecoflow.com/products/rapid-pro-x-power-bank',
        'https://es.ecoflow.com/products/rapid-pro-27k-power-bank',
        'https://es.ecoflow.com/products/rapid-pro-20k-power-bank',
        'https://es.ecoflow.com/products/rapid-pro-desktop-charger-320w',
    ],
    us: [
        'https://us.ecoflow.com/products/ecoflow-rapid-pro-x-power-bank-27650mah-300w',
        'https://us.ecoflow.com/products/ecoflow-rapid-pro-power-bank-27650mah-300w-140w-built-in-cable',
        'https://us.ecoflow.com/products/ecoflow-rapid-pro-power-bank-20000mah-230w-100w-built-in-cable',
        'https://us.ecoflow.com/products/ecoflow-rapid-pro-3-in-1-power-bank-10000mah-67w',
    ],
    ca: [
        'https://ca.ecoflow.com/products/ecoflow-rapid-pro-x-power-bank-27-650mah-300w',
        'https://ca.ecoflow.com/products/ecoflow-rapid-pro-power-bank-27-650mah-300w-140w-built-in-cable',
        'https://ca.ecoflow.com/products/ecoflow-rapid-pro-power-bank20-000mah-230w-100w-built-in-cable',
        'https://ca.ecoflow.com/products/ecoflow-rapid-pro-3-in-1-power-bank-10-000mah-67w',
    ],
    ph: [
        'https://ph.ecoflow.com/products/ecoflow-rapid-pro-power-bank-27650mah-300w-140w-built-in-cable',
        'https://ph.ecoflow.com/products/ecoflow-rapid-pro-power-bank-20000mah-230w-100w-built-in-cable',
        'https://ph.ecoflow.com/products/ecoflow-rapid-pro-3-in-1-power-bank-10000mah-67w',
        '',
    ],
};
